import { Link } from "react-router-dom";
import { FaInstagram, FaLinkedin, FaGithub } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-black text-white relative overflow-hidden">

      {/* 🔥 TOP GLOW LINE */}
      <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-green-400 to-transparent"></div>

      {/* 🔥 BACKGROUND GLOW */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 
      w-[500px] h-[200px] bg-green-400/10 blur-3xl"></div>

      {/* 🔥 MAIN CONTENT */}
      <div className="max-w-7xl mx-auto px-6 md:px-20 py-16 
      grid grid-cols-1 md:grid-cols-4 gap-12 text-center md:text-left relative z-10">

        {/* ✅ BRAND */}
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-green-400 tracking-wide">
            PRINTEZZ_
          </h2>

          <p className="text-gray-400 text-sm leading-relaxed max-w-xs mx-auto md:mx-0">
            Scan. Upload. Print. Instantly.
            <br />
            Fast, secure & hassle-free printing solution.
          </p>
        </div>

        {/* ✅ SERVICES + CONTACT (Mobile: Side by Side) */}
        <div className="grid grid-cols-2 gap-6 md:contents">

          {/* SERVICES */}
          <div>
            <h3 className="font-semibold mb-5 text-white">Services</h3>

            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="hover:text-green-400 transition cursor-pointer">Document Printing</li>
              <li className="hover:text-green-400 transition cursor-pointer">QR Scan Printing</li>
              <li className="hover:text-green-400 transition cursor-pointer">Instant Print</li>
              <li className="hover:text-green-400 transition cursor-pointer">Secure Upload</li>
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h3 className="font-semibold mb-5 text-white">Contact</h3>

            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="hover:text-green-400 transition">support@printezz.com</li>
              <li className="hover:text-green-400 transition">+91 8957160738</li>
              <li className="text-green-400 font-medium">Available 24x7</li>
            </ul>
          </div>

        </div>

        {/* ✅ SOCIAL / EXTRA (Desktop Only Balance) */}
        <div className="flex flex-col justify-between items-center md:items-start">

          <div>
            <h3 className="font-semibold mb-5 text-white">Follow Us</h3>

            <div className="flex gap-4 text-xl text-gray-400 justify-center md:justify-start">
              <FaInstagram className="hover:text-green-400 cursor-pointer transition" onClick={() => window.open("https://www.instagram.com/printezz.app", "_blank")} />
              <FaLinkedin className="hover:text-green-400 cursor-pointer transition" />
              {/* <FaGithub className="hover:text-green-400 cursor-pointer transition" /> */}
            </div>
          </div>


        </div>

      </div>

      {/* 🔥 DIVIDER */}
      <div className="border-t border-green-400/10 mx-6 md:mx-20"></div>

      {/* 🔥 BOTTOM */}
      <div className="max-w-7xl mx-auto px-6 md:px-20 py-6 
      flex flex-col md:flex-row justify-between items-center gap-4 
      text-sm text-gray-500 text-center md:text-left">

        <p>
          © {new Date().getFullYear()} Printezz. All rights reserved.
        </p>

        <div className="flex gap-6">
          <Link to="/privacy" className="hover:text-green-400 transition">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-green-400 transition">
            Terms & Conditions
          </Link>
        </div>

      </div>

    </footer>
  );
}

export default Footer;